import apiConfig from "../config/api";
import { get } from "../helpers/request";

const apiCompany = `${apiConfig.apiUri}api/company/get`;
export const getCompanyDenunciaData = (companyRut) => get(`${apiCompany}/companyData/${companyRut}`);
export const getCompanyDetails = (companyRut) => get(`${apiCompany}/companyData/detail/${companyRut}`);
export const getSucursalDetails = (companyRut, sucursalId) => get(`${apiCompany}/office/detail/${companyRut}/${sucursalId}`);
export const GetCompanyValidOffices = (companyRut) => get(`${apiCompany}/validOffices/${companyRut}`);
